import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const scrollContainer = document.querySelector<HTMLElement>('[data-app-scroll-container]');

    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }

    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, search]);

  return null;
}
